import { FC, useContext, useState } from 'react'
import {
  Box,
  Typography,
  IconButton,
  Button,
  Modal,
  TextField,
} from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import CloseIcon from '@mui/icons-material/Close'
import SaveIcon from '@mui/icons-material/Save'
import {
  createPlaybook,
  updatePlaybook,
} from '../../../../services/playbook.service'
import { useToast } from '../../../../contexts/toast.context'
import { PlaybookContext } from '../../../../contexts/playbooks.context'
import { buildNode } from '../../../../utils/nodeBuilder'
import { createNode } from '../../../../services/node.service'

import styles from './styles.module.scss'
import { SpexNode } from '../../../../types/playbook.type'
import { ResponseError } from '../../../../types/response.type'

interface IProps {
  open: boolean
  onClose: () => void
}

const PlaybookCreateModal: FC<IProps> = ({ open, onClose }) => {
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')

  const { showToast } = useToast()
  const { refreshList } = useContext(PlaybookContext)

  const handleCreate = async () => {
    let resp

    try {
      resp = await createPlaybook({
        name,
        slug,
      })
    } catch (err: any) {
      console.error('catch', err)
      if (err instanceof ResponseError) {
        showToast('error', err.message)
        return
      } else {
        throw err
      }
    }

    if (!resp.data) {
      return
    }

    const playbook = resp.data
    refreshList()
    showToast('success', resp.message)

    let x = window.innerWidth / 2
    let y = window.innerHeight / 2

    const resp2 = await createNode(playbook.id, {
      id: 'ignored',
      position: { x, y },
      type: 'text',
      view: 'plain',
      data: { label: playbook.name },
    })
    if (!resp2.success) throw new Error('Failed to create initial node')
    const node = resp2.data

    const initialNodes: SpexNode[] = [
      buildNode(
        node.id.toString(),
        node.x,
        node.y,
        node.data,
        node.type,
        'plain',
      ),
    ]

    await updatePlaybook({
      ...playbook,
      nodes: initialNodes,
      edges: [],
      auto_layout_options: {
        direction: 'TB',
        algorithm: 'd3-hierarchy',
      },
    })
    onClose()
  }

  return (
    <Modal className={styles.modal} open={open} onClose={onClose}>
      <Box className={styles.modalContent}>
        <Box>
          <Box className={styles.header}>
            <Typography className={styles.title} id="title">
              Create a Playbook
            </Typography>
            <IconButton data-testid="closeButton" onClick={onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Box>
          <Box className={styles.selects}>
            <TextField
              label="Name"
              id="playbookTitleInp"
              value={name}
              onChange={(evt) => setName(evt.target.value)}
            />
          </Box>
          <Box className={styles.selects}>
            <TextField
              label="Slug"
              id="playbookSlugInp"
              value={slug}
              onChange={(evt) => setSlug(evt.target.value)}
            />
          </Box>
          <Box className={styles.actions}>
            <Button onClick={onClose} startIcon={<CloseIcon />}>
              Cancel
            </Button>
            <Button
              id="createPlaybook"
              onClick={handleCreate}
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Create
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PlaybookCreateModal
